/* K-WORLDWIDE — ARTICLE BEHAVIORS
   Reading progress bar + TOC auto-generation + smooth scroll + active link tracking
*/
(() => {
  'use strict';

  // === READING PROGRESS BAR ===
  const progressBar = document.querySelector('.kw-article-progress__fill');
  const articleBody = document.querySelector('.kw-article__body');

  if (progressBar && articleBody) {
    const updateProgress = () => {
      const rect = articleBody.getBoundingClientRect();
      const total = articleBody.offsetHeight - window.innerHeight;
      const scrolled = Math.max(0, -rect.top);
      const pct = total > 0 ? Math.min(100, (scrolled / total) * 100) : 0;
      progressBar.style.width = pct + '%';
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  // === TOC AUTO-GENERATION ===
  const tocList = document.querySelector('.kw-article-toc__list');

  if (tocList && articleBody) {
    const headings = articleBody.querySelectorAll('h2, h3');

    if (headings.length === 0) {
      // No headings → hide TOC container
      const tocContainer = document.querySelector('.kw-article-toc');
      if (tocContainer) tocContainer.style.display = 'none';
    } else {
      headings.forEach((h, idx) => {
        // Generate stable id if missing
        if (!h.id) {
          const slug = h.textContent
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/^-|-$/g, '')
            .substring(0, 60);
          h.id = slug || ('h-' + idx);
        }

        const li = document.createElement('li');
        li.className = 'kw-article-toc__item kw-article-toc__item--' + h.tagName.toLowerCase();

        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.className = 'kw-article-toc__link';
        li.appendChild(a);
        tocList.appendChild(li);
      });

      // Smooth scroll on TOC click
      tocList.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href');
          const target = document.querySelector(targetId);
          if (target) {
            const offset = 80;
            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: 'smooth' });
            // Update URL without jump
            history.replaceState(null, null, targetId);
          }
        });
      });

      // Active link tracking via IntersectionObserver
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            tocList.querySelectorAll('a').forEach(a => a.classList.remove('is-active'));
            const link = tocList.querySelector('a[href="#' + entry.target.id + '"]');
            if (link) link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-80px 0px -70% 0px' });

      headings.forEach(h => observer.observe(h));
    }
  }

})();